"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _types = require("../types");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var FieldElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.FieldElementDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("field", _flowRuntime["default"].ref(FieldElementDefinition)), _flowRuntime["default"].property("position", _flowRuntime["default"].union(_flowRuntime["default"].string("before"), _flowRuntime["default"].string("after")), true)));

var FieldDescription = function FieldDescription(_arg) {
  var field = _arg.field,
      position = _arg.position;
  var descriptionPosition = field.ui && field.ui.descriptionPosition;
  var descriptionTextSize = field.ui && field.ui.descriptionTextSize;

  if (field && field.description) {
    return !descriptionPosition && position === 'before' || descriptionPosition === position ? /*#__PURE__*/_react["default"].createElement("div", {
      className: descriptionTextSize === 'small' ? 'description--small' : 'description' // eslint-disable-next-line react/no-danger
      ,
      dangerouslySetInnerHTML: {
        __html: field.description
      }
    }) : null;
  }

  return null;
};

FieldDescription.defaultProps = {
  position: undefined
};
var _default = FieldDescription;
exports["default"] = _default;